import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './UserLogin.css';

interface UserLoginProps {
    login?: string;
    cls?: string;
}

const BLOCK = 'user-login';

export class UserLogin extends React.PureComponent<UserLoginProps> {
    render() {
        const { login, cls } = this.props;

        const loginStr = login || '–';

        return (
            <div className={classNames(Bem.cls(BLOCK), cls)}>
                <span className={Bem.cls(BLOCK, 'first-letter')}>
                    {loginStr[0]}
                </span>
                <span>{loginStr.slice(1)}</span>
            </div>
        );
    }
}
